export default __webpack_public_path__ + "static/media/mc_1Suit.55dc85ec.png";